<div class="fullcontainer" >
    <br />
    <br />
  
    <div class='titleContainer'>
      <h2 class='header' style='color: #006498'>All Calendars</h2>
      <div>
      <button class='btn btn-secondary' routerLink='/calendar/new'><i class="fas fa-plus"></i> New</button>&nbsp;
      </div>
    </div>
    <br /> 
    <br />
    <app-grid
  entity='calendar'
  [filters]='this.filters'
  [columns]='this.columns'
  [buttons]='this.buttons'
  [searchFilters]='this.searchFilters'
  [searchFields]='this.searchFields'
  ></app-grid>
  